<template>
  <RawRecords v-if="showRawOutput" :records="records" />
  <table v-else-if="processedRecords.length !== 0">
    <colgroup>
      <col class="w-3/4">
      <col class="w-1/4">
    </colgroup>
    <thead>
      <tr class="border-b-2 border-gray-200 text-left">
        <th scope="col" class="py-1.5 font-medium">Name server</th>
        <th scope="col" class="py-1.5 font-medium">Revalidate in</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(record, index) in processedRecords" :key="index" class="group">
        <td class="py-1">
          <span>
            <dns-records-link :domain="record.record.target" class="text-blue-600 hover:text-blue-800 hover:underline" />
          </span>
          <CnameChainBadge :chain="record.cnameChain" />
          <copy :content="record.record.target" class="[visibility:hidden] group-hover:visible" />
        </td>
        <td class="py-1">
          <duration :seconds="record.record.ttl" />
        </td>
      </tr>
    </tbody>
  </table>
  <div v-else>
    <span>No NS records found.</span>
    <Alert type="info">The name servers for this domain are inherited from one of its ancestor domains. Try its parent domain:
      <dns-records-link :domain="parentDomain" class="font-semibold hover:underline" />.
    </Alert>
  </div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import { useStore } from 'vuex';
import Copy from '@/components/micro/CopyComponent.vue';
import Duration from '@/components/micro/DurationComponent.vue';
import RawRecords from '@/components/micro/RawRecords.vue';
import Alert from '@/components/micro/AlertComponent.vue';
import CnameChainBadge from '@/components/micro/CnameChainBadge.vue';
import DnsRecordsLink from '@/components/micro/DnsRecordsLink.vue';
import { NS, QueryResult, RecordInfo } from '@/model/Api';

type NsRecordWithInfo = {
  record: NS;
} & RecordInfo

const props = defineProps({
  records: {
    type: Object as PropType<QueryResult>,
    required: true,
  },
  domain: {
    type: String,
    required: true,
  },
});

const store = useStore();
const showRawOutput = computed(() => store.state.showRawOutput);

const processedRecords = computed(() => {
  const processed: NsRecordWithInfo[] = props.records.response.answer.filter((item): item is NsRecordWithInfo => item.record.recordType === 'NS');
  return processed;
});
const parentDomain = computed(() => props.domain.substring(props.domain.indexOf('.') + 1));
</script>
